<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <awair-floor-plan-editor-sidebar-header
    [name]="(selectedFloor$ | async) ? (selectedFloor$ | async).name : 'Floor List'"
    [isSelected]="(selectedFloor$ | async) != null"
    [isFloorPlanEdited]="isFloorPlanEdited$ | async"
    (clickBack)="toFloorList()">
  </awair-floor-plan-editor-sidebar-header>

  <ng-container *ngIf="(hasFloor$ | async) as hasFloor; else noFloor">
    <section class="__list">
      <!-- List Switch -->
      <ng-container [ngSwitch]="selectedFloor$ | async">
        <!-- Floor List -->
        <awair-floor-list *ngSwitchCase="null"
                          [floors]="floors$ | async"
                          [canDelete]="true"
                          (selectFloor)="onSelectFloor($event)"
                          (deleteFloor)="onDeleteFloor($event, selectedOrganization.token)">
        </awair-floor-list>
        <!-- /.Floor List -->

        <!-- Device List -->
        <awair-floor-plan-editor-device-list *ngSwitchDefault
                                             [devicesWithUuidAndStatus]="devicesWithUuidAndStatus$ | async">
        </awair-floor-plan-editor-device-list>
        <!-- /.Device List -->
      </ng-container>
      <!-- /.List Switch -->
    </section>
  </ng-container>
  <ng-template #noFloor>
    <section class="__list-no-floor">
      <button class="__create-button"
              (click)="onCreateFloor(selectedOrganization.token)">
        <span class="__button-wrapper">
          <awair-plus-icon style="margin-right: 8px;" [color]="'#FFFFFF'"></awair-plus-icon>
          Create New Floor
        </span>
      </button>
    </section>
  </ng-template>

  <div class="__divider-bottom"></div>
  <footer class="__list-footer">
    <ng-container *ngIf="(selectedFloor$ | async) == null">
      <button class="__footer-create-button"
              (click)="onCreateFloor(selectedOrganization.token)">
        <span class="__button-wrapper">
          <awair-plus-icon [color]="'#495056'"
                           [size]="{width: 17, height: 17}">
          </awair-plus-icon>
        </span>
      </button>
      <div class="__divider-right"></div>
    </ng-container>
  </footer>
</ng-container>

